import "./inicio.scss";
export default function Inicio() {


  return (
    <div className="inicio" id="inicio">
      <video autoPlay muted playsInline src="assets/img/presentacion.mp4"></video>
      
    </div>

  );
}
